import LocaleMixins from 'utils/vue/mixins/lang'
import SettingsMixins from 'utils/vue/mixins/settings'
import {map} from 'utils/vue/lib/formatters'
import {BLOCKS} from '../../constants/would-you-like-to'

const mixins = [LocaleMixins, SettingsMixins]

export const T = {
  PLAYCARD: 'products.types.playcard.alias',
  PLAYCARD_TC: 'products.types.playcard.alias_title_case'
}

export default {
  mixins,
  computed: {
    T_PRODUCTS() {
      return _.mapValues(T, path => this.$$t(path, null))
    },
    PLAYCARD() {
      return this.T_PRODUCTS['PLAYCARD'] || 'play card'
    },
    PLAYCARD_TC() {
      return this.T_PRODUCTS['PLAYCARD_TC'] || 'Play Card'
    },
    PLAYCARD_ALIASES() {
      return _.keys(T)
    },
    PLAYCARD_ALIASE_PATHS() {
      return _.values(T)
    }
  },
  methods: {
    translateProductName(template, keys = [], dataSource = {}) {
      const data = {
        ...dataSource || {},
        ..._.omitBy(_.pick(this, _.keys(this.T_PRODUCTS)), v => _.isNil(v)),
        ..._.omitBy(this.T_PRODUCTS, v => _.isNil(v))
      }
      if (_.isObject(template)) {
        return map(template, item => {
          _.forEach(keys, key => {
            _.set(item, key, this.$$templify(_.get(item, key), data))
          })
          return item
        })
      }
      return this.$$templify(template, data)
    },
    getFilteredWouldYouLikeBlocks(originalBlocks) {
      const blocks = _.cloneDeep(originalBlocks || BLOCKS)
      const filters = this.$$s('wouldYouLikeTo', [])
      return _.reduce(filters, (items, route) => {
        if (_.isObject(route)) {
          if (!_.isEmpty(route) && !route.disabled) {
            items.push(route)
          }
        } else {
          const block = _.find(blocks, block => block.route === route)
          if (block) {
            items.push(block)
          }
        }
        return items
      }, [])
    }
  }
}
